/**
 * Core entity registry. Table name == entity name. Nothing here knows what a
 * "carpet cleaner" is; presets rename these through terminology.
 */
export const CORE_ENTITIES = [
    'customers',
    'contacts',
    'service_locations',
    'services',
    'quotes',
    'jobs',
    'appointments',
    'staff',
    'invoices',
    'payments',
    'credit_notes',
    'expenses',
    'vendors',
    'bank_transactions',
    'documents',
];
export function isCoreEntity(value) {
    return CORE_ENTITIES.includes(value);
}
/** Singular name used in event types and rule contexts (invoice.created, ctx.invoice). */
export const ENTITY_SINGULAR = {
    customers: 'customer',
    contacts: 'contact',
    service_locations: 'service_location',
    services: 'service',
    quotes: 'quote',
    jobs: 'job',
    appointments: 'appointment',
    staff: 'staff',
    invoices: 'invoice',
    payments: 'payment',
    credit_notes: 'credit_note',
    expenses: 'expense',
    vendors: 'vendor',
    bank_transactions: 'bank_transaction',
    documents: 'document',
};
export const SINGULAR_TO_ENTITY = Object.fromEntries(Object.entries(ENTITY_SINGULAR).map(([plural, singular]) => [singular, plural]));
export const AREAS = [
    'customers',
    'catalog',
    'quotes',
    'jobs',
    'scheduling',
    'staff',
    'invoices',
    'payments',
    'banking',
    'expenses',
    'documents',
    'integrations',
    'reports',
    'customization',
    'rules',
    'proposals',
    'settings',
    'members',
    'audit',
    'intake',
];
export const ENTITY_AREA = {
    customers: 'customers',
    contacts: 'customers',
    service_locations: 'customers',
    services: 'catalog',
    quotes: 'quotes',
    jobs: 'jobs',
    appointments: 'scheduling',
    staff: 'staff',
    invoices: 'invoices',
    payments: 'payments',
    credit_notes: 'invoices',
    expenses: 'expenses',
    vendors: 'expenses',
    bank_transactions: 'banking',
    documents: 'documents',
};
/** True when a permission list grants `needed`. Mirrors app.has_permission() in SQL. */
export function hasPermission(granted, needed) {
    if (granted.includes('*') || granted.includes(needed))
        return true;
    const [area, verb] = needed.split('.');
    if (granted.includes(`${area}.*`))
        return true;
    if (verb === 'read' && granted.includes(`${area}.write`))
        return true;
    return false;
}
export const MODULES = [
    'customers',
    'catalog',
    'quotes',
    'jobs',
    'scheduling',
    'invoicing',
    'payments',
    'banking',
    'expenses',
    'documents',
    'integrations',
    'intake',
];
export const MODULE_DESCRIPTIONS = {
    customers: 'Customers, contacts and service locations',
    catalog: 'Services and price lists',
    quotes: 'Quotes that convert into jobs',
    jobs: 'Jobs: the unit of work',
    scheduling: 'Appointments and staff assignments',
    invoicing: 'Invoices and credit notes',
    payments: 'Payments and allocations',
    banking: 'Bank accounts, transactions and reconciliation',
    expenses: 'Expenses and vendors',
    documents: 'File attachments on any record',
    integrations: 'Email, calendar and bank feed connections',
    intake: 'Public request forms and submission review',
};
export const TENANT_ROLES = ['owner', 'admin', 'member', 'viewer'];
/** Status vocabularies, kept here so tools, UI and rules agree. */
export const STATUS = {
    customers: ['lead', 'active', 'archived'],
    quotes: ['draft', 'sent', 'accepted', 'declined', 'expired'],
    jobs: ['draft', 'scheduled', 'in_progress', 'completed', 'cancelled', 'invoiced'],
    appointments: [
        'scheduled',
        'confirmed',
        'en_route',
        'in_progress',
        'done',
        'cancelled',
        'no_show',
    ],
    invoices: ['draft', 'sent', 'partially_paid', 'paid', 'overdue', 'void'],
    payments: ['received', 'refunded', 'bounced'],
    expenses: ['draft', 'recorded', 'reconciled'],
    bank_transactions: ['unmatched', 'matched', 'excluded'],
    proposals: ['pending', 'approved', 'rejected', 'applied', 'failed', 'expired'],
};
export const PAYMENT_METHODS = [
    'cash',
    'cheque',
    'card',
    'etransfer',
    'bank_transfer',
    'other',
];
export const LINE_KINDS = ['service', 'discount', 'fee', 'adjustment'];
//# sourceMappingURL=entities.js.map